import whalesApi from "@/services/api/whales";

function formatWhaleForApi(whale) {
  // just in case
  return whale;
}

const state = {
  whale: {},
  isSaving: false,
  isSaved: false,
  isDialogOpen: false,
  message: "",
  sightings: [],
  isLoadingSightings: false,
  whaleImages: [],
  unassociatedImages: [],
  isLoadingImages: false
};

const getters = {
  saving: (state) => state.isSaving,
  saved: (state) => state.isSaved,
  whale: (state) => state.whale,
  dialog: (state) => state.isDialogOpen,
  button: (state) => (state.whale && state.whale.id ? "Save" : "Create"),
  title: (state) =>
    state.whale && state.whale.id
      ? `Edit Whale ${state.whale.whaleId}`
      : "Create New Whale",
  message: (state) => state.message,
  sightings: (state) => state.sightings,
  loadingSightings: (state) => state.isLoadingSightings,
  whaleImages: (state) => state.whaleImages,
  unassociatedImages: (state) => state.unassociatedImages,
  loadingImages: (state) => state.isLoadingImages
};

const actions = {
  open({commit}, {whale}) {
    commit("open", {whale});
  },
  close({commit}) {
    commit("close");
  },
  async update({commit, dispatch}, whale) {
    commit("saving", {isSaving: true});

    const whaleResult = await whalesApi.update(
        whale.id,
        formatWhaleForApi(whale)
    );

    if (whaleResult) {
      dispatch("whales/reload", {}, {root: true});
      commit("saveComplete", {isSaveComplete: true});
    } else {
      commit("saveComplete", {isSaveComplete: false});
    }
  },
  async create({commit, dispatch}, whale) {
    commit("saving", {isSaving: true});
    const whaleResult = await whalesApi.create(whale);

    if (whaleResult) {
      dispatch("whales/reload", {}, {root: true});
      dispatch("whales/loadUnregisteredWhales", {}, {root: true});
      commit("saveComplete", {isSaveComplete: true});
    } else {
      commit("saveComplete", {isSaveComplete: false});
    }
  },
  resetSaving({commit}) {
    commit("saving", {isSaving: false})
  },
  setMessage({commit}, message) {
    commit("setMessage", message);
  },
  async loadSightings({commit}, whaleId) {
    if (!whaleId) {
      commit("setSightings", []);
      return;
    }
    commit("setLoadingSightings", true);
    const result = await whalesApi.sightingsForWhale(whaleId);
    commit("setSightings", result.data);
    commit("setLoadingSightings", false);
  },
  async loadPickerImages({commit}, whaleId) {
    commit("setWhaleImages", []);
    commit("setUnassociatedImages", []);
    commit("setLoadingImages", true);
    if (whaleId) {
      const [whaleResult, unassociatedResult] = await Promise.all([
        whalesApi.imagesForWhale(whaleId),
        whalesApi.unassociatedImages(),
      ]);
      commit("setWhaleImages", whaleResult.data);
      commit("setUnassociatedImages", unassociatedResult.data);
    } else {
      const allResult = await whalesApi.allImages();
      const associated = [];
      const unassociated = [];
      for (const img of allResult.data) {
        if (img.whaleId && img.whaleId !== '' && img.whaleId !== 'na') {
          associated.push(img);
        } else {
          unassociated.push(img);
        }
      }
      commit("setWhaleImages", associated);
      commit("setUnassociatedImages", unassociated);
    }
    commit("setLoadingImages", false);
  },
  async setFeaturePhoto({commit, dispatch}, {whaleId, imageId}) {
    const result = await whalesApi.setFeaturePhoto(whaleId, imageId);
    if (result) {
      commit("updateFeaturePhoto", result.data);
      dispatch("whales/reload", {}, {root: true});
    }
  },
}

const mutations = {
  open(state, { whale }) {
    state.whale = { ...whale };
    state.isSaving = false;
    state.isDialogOpen = true;
    state.message = "";
    state.sightings = [];
    state.whaleImages = [];
    state.unassociatedImages = [];
  },
  close(state) {
    state.isDialogOpen = false;
    state.isSaving = false;
    state.whale = {};
    state.message = "";
    state.sightings = [];
    state.whaleImages = [];
    state.unassociatedImages = [];
  },
  saving(state, { isSaving }) {
    state.isSaving = isSaving;
  },
  saveComplete(state, { isSaveComplete }) {
    if (isSaveComplete) {
      state.isSaved = true;
      state.isDialogOpen = false;
      state.whale = {};
    }
    state.isSaving = false;
  },
  setMessage(state, message) {
    state.message = message;
  },
  setSightings(state, sightings) {
    state.sightings = sightings;
  },
  setLoadingSightings(state, isLoading) {
    state.isLoadingSightings = isLoading;
  },
  setWhaleImages(state, images) {
    state.whaleImages = images;
  },
  setUnassociatedImages(state, images) {
    state.unassociatedImages = images;
  },
  setLoadingImages(state, isLoading) {
    state.isLoadingImages = isLoading;
  },
  updateFeaturePhoto(state, whale) {
    state.whale = { ...whale };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
